import React from 'react'
import moment from 'moment'

// material-ui components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import Timeline from 'components/Timeline/Timeline.jsx'
import CalendarModalForm from 'components/CalendarModalForm/CalendarModalForm'
import { PortalIndicators, getPortalsFromOffer } from 'components/Portal/Portal.jsx'

import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'

// material-ui icons
import Add from 'material-ui-icons/Add'
import Edit from 'material-ui-icons/Edit'
import Event from 'material-ui-icons/Event'
import Phone from 'material-ui-icons/Phone'
import Email from 'material-ui-icons/Email'
import Assignment from 'material-ui-icons/Assignment'
import Mic from 'material-ui-icons/Mic'
import SupervisorAccount from 'material-ui-icons/SupervisorAccount'
import Alarm from 'material-ui-icons/Alarm'
import Adjust from 'material-ui-icons/Adjust'
import FiberManualRecord from 'material-ui-icons/FiberManualRecord'
import Note from 'material-ui-icons/Note'
import Description from 'material-ui-icons/Description'
import LooksOne from 'material-ui-icons/LooksOne'
import LooksTwo from 'material-ui-icons/LooksTwo'

class Azioni extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      eventsType: 'timeline',
      showModal: false,
      initialValues: {},
      isNewEvent: true,
      error: '',
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false,
      initialValues: {},
      error: '',
    })
  }

  setErrorMessage = (errorMessage) => {
    this.setState({
      error: errorMessage,
    })
  }

  addAction = () => {
    const { clienteId, agenteId, utenteId, isAgente } = this.props

    const initialValues = {
      tipoEvento: '',
      campagnaId: null,
      offertaId: null,
      start: '',
      end: '',
      agenteId: agenteId, //DA CONTROLLARE!!!
      promemoriaUtenteId: utenteId,
      promemoriaDataOra: moment().toDate(),
      promemoriaDismesso: false,
      clienteId: clienteId,
      luogo: '',
      appuntamentoOrigine:'',
      stato: !!isAgente ? 'FISSATO_AGENTE' : '',
      descrizione: '',
      dataOra: moment().toDate(),
      nonRisposto: false,
      title: '',
    }

    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: true,
    })
  }

  editAction = (azione) => (event) => {
    event.preventDefault()

    const editActionTitle = (tipoAzione) => {
      switch (tipoAzione.toLowerCase()) {
        case 'appuntamento':
          return 'appuntamento'
        case 'telefonata in':
          return 'telefonata in entrata'
        case 'telefonata out':
          return 'telefonata in uscita'
        case 'whatsapp in':
          return 'whatsapp in entrata'
        case 'whatsapp out':
          return 'whatsapp in uscita'
        case 'email in':
          return 'email in entrata'
        case 'email out':
          return 'email in uscita'
        case 'form':
          return 'form'
        case 'sondaggio form':
          return 'sondaggio form'
        case 'sondaggio appuntamento':
          return 'sondaggio appuntamento'
        case 'assegnazione agente':
          return 'assegnazione agente'
        case 'promemoria':
          return 'promemoria'
        case 'preliminare':
          return 'preliminare'
        case 'propsta acquisto':
          return 'proposta di acquisto'
        default:
          return 'azione'
      }
    }

    const initialValues = {
      id: azione.id,
      tipoEvento: azione.tipoAzione.tipo,
      campagnaId: azione.campagnaId,
      offertaId: azione.offertaId,
      start: moment(azione.appuntamentoDaDataOra).toDate(),
      end: moment(azione.appuntamentoADataOra).toDate(),
      agenteId: azione.appuntamentoAgenteId,
      promemoriaUtenteId: azione.promemoriaUtenteId,
      promemoriaDataOra: moment(azione.promemoriaDataOra).toDate(),
      promemoriaDismesso: false,
      clienteId: azione.clienteId,
      luogo: azione.appuntamentoLuogo,
      appuntamentoOrigine:azione.appuntamentoOrigine,
      stato: azione.appuntamentoStato,
      descrizione: azione.descrizione,
      dataOra: moment(azione.dataOra).toDate(),
      nonRisposto: azione.nonRisposto,
      title: `Modifica ${editActionTitle(azione.tipoAzione.tipo)}`,
    }

    this.setState({
      showModal: true,
      initialValues: initialValues,
      isNewEvent: false,
    })
  }

  actionInverted(tipoAzione) {
    switch (tipoAzione.toLowerCase()) {
      case 'appuntamento':
        return 0
      case 'telefonata in':
        return 1
      case 'telefonata out':
        return 0
      case 'email in':
        return 1
      case 'email out':
        return 0
      case 'whatsapp in':
        return 1
      case 'whatsapp out':
        return 0
      case 'form':
        return 1
      case 'sondaggio form':
        return 1
      case 'sondaggio appuntamento':
        return 1
      case 'assegnazione agente':
        return 0
      case 'promemoria':
        return 1
      case 'nota':
        return 1
      case 'proposta acquisto':
        return 0
      case 'preliminare':
        return 0
      case 'email automatica 1 out':
        return 0
      case 'email automatica 2 out':
        return 0
      default:
        return 0
    }
  }

  actionTitle(tipoAzione) {
    switch (tipoAzione.toLowerCase()) {
      case 'appuntamento':
        return 'Appuntamento'
      case 'telefonata in':
        return 'Telefonata in entrata'
      case 'telefonata out':
        return 'Telefonata in uscita'
      case 'email in':
        return 'Email in entrata'
      case 'email out':
        return 'Email in uscita'
      case 'whatsapp in':
        return 'Whatsapp in entrata'
      case 'whatsapp out':
        return 'Whatsapp in uscita'
      case 'form':
        return 'Form'
      case 'sondaggio form':
        return 'Sondaggio form'
      case 'sondaggio appuntamento':
        return 'Sondaggio appuntamento'
      case 'assegnazione agente':
        return 'Assegnazione agente'
      case 'promemoria':
        return 'Promemoria'
      case 'nota':
        return 'Nota'
      case 'proposta acquisto':
        return 'Proposta di acquisto'
      case 'preliminare':
        return 'Preliminare'
      case 'email automatica 1 out':
        return 'Email automatica 1'
      case 'email automatica 2 out':
        return 'Email automatica 2'
      default:
        return 'Azione'
    }
  }

  actionColor(tipoAzione) {
    switch (tipoAzione.toLowerCase()) {
      case 'appuntamento':
        return 'danger'
      case 'telefonata in':
        return 'warning'
      case 'telefonata out':
        return 'info'
      case 'email in':
        return 'warning'
      case 'email out':
        return 'info'
      case 'whatsapp in':
        return 'success'
      case 'whatsapp out':
        return 'success'
      case 'form':
        return 'primary'
      case 'sondaggio form':
        return 'success'
      case 'sondaggio appuntamento':
        return 'success'
      case 'assegnazione agente':
        return 'rose'
      case 'promemoria':
        return 'highlight'
      case 'nota':
        return 'yellow'
      case 'email automatica 1 out':
      case 'email automatica 2 out':
        return 'gray'
      default:
        return 'gray'
    }
  }

  actionIcon(tipoAzione) {
    switch (tipoAzione.toLowerCase()) {
      case 'appuntamento':
        return Event
      case 'telefonata in':
        return Phone
      case 'telefonata out':
        return Phone
      case 'email in':
        return Email
      case 'email out':
        return Email
      case 'form':
        return Assignment
      case 'sondaggio form':
        return Mic
      case 'sondaggio appuntamento':
        return Mic
      case 'assegnazione agente':
        return SupervisorAccount
      case 'promemoria':
        return Alarm
      case 'nota':
        return Note
      case 'proposta acquisto':
      case 'preliminare':
        return Description
      case 'email automatica 1 out':
        return LooksOne
      case 'email automatica 2 out':
        return LooksTwo
      default:
        return Adjust
    }
  }

  actionMeetingStatus(statoAppuntamento) {
    switch (statoAppuntamento.toLowerCase()) {
      case 'fissato_agente':
        return 'Fissato agente'
      case 'confermato_segretaria':
        return 'Confermato segretaria'
      case 'confermato_cliente':
        return 'Confermato cliente'
      case 'annullato_cliente':
        return 'Disdetto cliente'
      case 'saltato':
        return 'Saltato'
      case 'fatto':
        return 'Fatto'
      default:
        return ''
    }
  }

  convertToTimeline = (azione, index) => {
    const { utenteId } = this.props

    return {
      inverted: this.actionInverted(azione.tipoAzione.tipo), //index % 2 === 1,
      badgeColor: this.actionColor(azione.tipoAzione.tipo),
      badgeIcon: this.actionIcon(azione.tipoAzione.tipo),
      title: this.actionTitle(azione.tipoAzione.tipo),
      titleColor: this.actionColor(azione.tipoAzione.tipo),
      body: (
        <div>
          <p style={{ whiteSpace: 'pre-wrap' }}>{azione.descrizione}</p>
          {azione.tipoAzione.tipo.toLowerCase() === 'appuntamento' && (
            <p>
              <b>Appuntamento</b>
              <br />
              Agente: {azione.appuntamentoAgente.nome}
              <br />
              Stato: {this.actionMeetingStatus(azione.appuntamentoStato)}
              <br />
              Data e ora: {moment(azione.appuntamentoDaDataOra).format('DD/MM/YYYY HH:mm')} -{' '}
              {moment(azione.appuntamentoADataOra).format('DD/MM/YYYY HH:mm')}
              <br />
              Luogo di incontro: {azione.appuntamentoLuogo}
              {azione.appuntamentoFissatoOperatore && (
                <span style={{ color: '#0476be' }}>
                  <br />
                  <i>
                    Fissato da {azione.appuntamentoFissatoOperatore}
                    {azione.appuntamentoFissatoData && (
                      <span>
                        {' '}
                        il {moment(azione.appuntamentoFissatoData).format('DD/MM/YYYY HH:mm')}
                      </span>
                    )}
                  </i>
                </span>
              )}
              
              <br />
              Origine : {azione.appuntamentoOrigine}
              {azione.appuntamentoConfermatoSegretariaOperatore && (
                <span style={{ color: '#0476be' }}>
                  <br />
                  <i>
                    Confermato da {azione.appuntamentoConfermatoSegretariaOperatore}{' '}
                    {azione.appuntamentoConfermatoSegretariaData && (
                      <span>
                        {' '}
                        il{' '}
                        {moment(azione.appuntamentoConfermatoSegretariaData).format(
                          'DD/MM/YYYY HH:mm'
                        )}
                      </span>
                    )}
                  </i>
                </span>
              )}
            </p>
          )}
          {/* {(azione.tipoAzione.tipo.toLowerCase() === 'telefonata out' ||
            azione.tipoAzione.tipo.toLowerCase() === 'email out' ||
            azione.tipoAzione.tipo.toLowerCase() === 'whatsapp out') &&
            azione.nonRisposto && (
              <p>
                <b>Non ha risposto</b>
              </p>
            )} */}
          {(azione.tipoAzione.tipo.toLowerCase() === 'telefonata in' ||
            azione.tipoAzione.tipo.toLowerCase() === 'email in') &&
            (!!azione.offerta || !!azione.campagna) && (
              <p>
                <b>Offerta e provenienza</b>
                <br />
                {azione.offerta && (
                  <span>
                    {azione.offerta.nome}
                    <PortalIndicators portals={getPortalsFromOffer(azione.offerta)} showInactive={false} style={{ marginLeft: 6 }} />
                  </span>
                )}

                {azione.campagna && (
                  <span>
                    <br />
                    da {azione.campagna.nome}
                  </span>
                )}
              </p>
            )}
          {(azione.tipoAzione.tipo.toLowerCase() === 'sondaggio form' ||
            azione.tipoAzione.tipo.toLowerCase() === 'sondaggio appuntamento') && (
            <p>
              <b>Voto agente</b>
              <br />
              {azione.votoAgente}
            </p>
          )}
          {azione.tipoAzione.tipo.toLowerCase() === 'assegnazione agente' && (
            <p>
              <b>Agente assegnato</b>
              <br />
              {azione.utente.nome}
            </p>
          )}
          {azione.tipoAzione.tipo.toLowerCase() === 'form' && (
            <p>
              <b>Form e provenienza</b>
              <br />
              {azione.offerta && (
                <span>
                  {azione.offerta.tipoOfferta.tipo}, {azione.offerta.nome}
                  <PortalIndicators portals={getPortalsFromOffer(azione.offerta)} showInactive={false} style={{ marginLeft: 6 }} />
                </span>
              )}

              {azione.campagna && (
                <span>
                  <br />
                  da {azione.campagna.nome}
                </span>
              )}

              {azione.utenteId && (
                <span style={{ color: '#0476be' }}>
                  <br />
                  <i>Creato da: {azione.utente.nome}</i>
                </span>
              )}
            </p>
          )}
          {azione.tipoAzione.tipo.toLowerCase() === 'promemoria' && (
            <div>
              <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                {!!azione.promemoriaDismesso ? (
                  <FiberManualRecord color="disabled" style={{ width: '18px', height: '18px' }} />
                ) : (
                  <FiberManualRecord color="error" style={{ width: '18px', height: '18px' }} />
                )}
              </div>
              <p>
                <b>Dettagli</b>
                {this.props.utenteId !== azione.promemoriaUtenteId && (
                  <span>
                    <br />
                    per{' '}
                    <b style={{ color: '#f54236' }}>
                      {azione.promemoriaUtente && azione.promemoriaUtente.nome}
                    </b>
                  </span>
                )}
                <br />
                fissato il {moment(azione.promemoriaDataOra).format('DD-MM-YYYY HH:mm')}
              </p>
            </div>
          )}
        </div>
      ),
      footer: (
        <div>
          <small>{moment(azione.dataOra).format('DD/MM/YYYY HH:mm')}</small>
          {(azione.tipoAzione.tipo === 'appuntamento' ||
            azione.tipoAzione.tipo === 'telefonata in' ||
            azione.tipoAzione.tipo === 'telefonata out' ||
            azione.tipoAzione.tipo === 'whatsapp in' ||
            azione.tipoAzione.tipo === 'whatsapp out' ||
            azione.tipoAzione.tipo === 'email in' ||
            azione.tipoAzione.tipo === 'email out' ||
            (azione.tipoAzione.tipo === 'form' && azione.utenteId === utenteId) ||
            azione.tipoAzione.tipo === 'promemoria' ||
            azione.tipoAzione.tipo === 'nota' ||
            azione.tipoAzione.tipo === 'preliminare' ||
            azione.tipoAzione.tipo === 'proposta acquisto') && (
            <IconButton
              style={{
                float: 'right',
                fontSize: '16px',
                width: 20,
                height: 20,
              }}
              onClick={this.editAction(azione)}
            >
              <Edit />
            </IconButton>
          )}
        </div>
      ),
    }
  }

  render() {
    const { azioni, isAgente, canCreateForm } = this.props
    const { eventsType, showModal, initialValues, isNewEvent } = this.state

    return (
      <div>
        <GridContainer justify="center" direction="row">
          <ItemGrid xs={10}>
            <Button
              style={{ float: 'right' }}
              variant="raised"
              color="primary"
              onClick={this.addAction}
            >
              <Add /> Aggiungi azione
            </Button>
            <Timeline stories={azioni.map(this.convertToTimeline)} />
          </ItemGrid>
        </GridContainer>

        <CalendarModalForm
          eventsType={eventsType}
          initialValues={initialValues}
          isNewEvent={isNewEvent}
          open={!!showModal}
          onCloseModal={this.closeModal}
          onSetErrorMessage={this.setErrorMessage}
          isAgente={!!isAgente}
          canCreateForm={!!canCreateForm}
        />
      </div>
    )
  }
}

export default Azioni



// WEBPACK FOOTER //
// ./src/views/App/Clienti/Azioni.jsx